<template>
<tr>
    <td class="TORDes">
    {{this.operazione.Descrizione}}
    </td>
    <td class="TORNot">
    <span>Note</span>
    <form class="Form TableForm">
        <div class="FormRow">
        <div class="FormBox80">
            <input type="text" id="" name="" placeholder="Aggiungi nota" v-model="this.noteOperazione"/>
        </div>
            <div class="FormBox16">
                <div class="TwinButtons Min">
                    <div class="Button ExtraSmall">
                        <input type="button" id="" name=""  value="Salva" @click="this.updateOperazione(1, 0)" />
                    </div>
                </div>
            </div>
        </div>
    </form>
    </td>
    <td class="TORSel">
    <span>Esito</span>
        <form class="Form" id="opForm">
            <div class="FormRow">
                <div class="FormBoxWide">
                    <div class="FormRow StorkedBox" ref="FormBox">
                        <div class="FormBox33 myPadding">
                            <label for="Positivo" class="Centeredtext">Positivo</label>
                            <input type="radio" class="radioPers" name="esito" id="Positivo" value="1POSITIVO" v-model="this.checkedEsito" @click="this.userInput">
                        </div>
                        <div class="FormBox33 myPadding">
                            <label for="Positivo" class="Centeredtext">Negativo</label>
                            <input type="radio" class="radioPers" name="esito" id="Negativo" value="0NEGATIVO" v-model="this.checkedEsito" @click="this.userInput">
                        </div>
                        <div class="FormBox33 myPadding">
                            <label for="Positivo" class="Centeredtext">N. A.</label>
                            <input type="radio" class="radioPers" name="esito" id="Nullo" value="0NONAPPLICABILE" v-model="this.checkedEsito" @click="this.userInput">
                        </div>
                    </div>
                </div>
                <div class="FormBox50" v-if="this.resetVisible">
                    <div class="Button ExtraSmall Stroked">
                        <input type="button" id="" name="" value="Annulla Selezione" @click="this.clearSelection"/>
                        <input type="text" id="esitoSelected" style="display:none;">
                    </div>
                </div>
            </div>
        </form>
    </td>
</tr>
</template>

<script>

import {apiMixin} from "/mixin.js";


export default {
    name: "OperazioneRiga",
    props: {
        operazione: Object,
        index: Number
    },  
    data(){
        return {
            noteOperazione: this.operazione.Note,            
            esitoOperazione: "",
            eseguitaOprazione: 0,
            checkedEsito:"",
            resetVisible: false,
            userIn: false
        }
    },
    mixins: [apiMixin],
    methods: {
        updateOperazione: function(mettiNote, mettiEsito){

            let dataUpdate = {
                SysChiaveglobale: this.operazione.SysChiaveglobale           
            };

            if(mettiNote){
                dataUpdate.Note = this.noteOperazione;
            }
            if(mettiEsito){                
                dataUpdate.CodiceEsito =  this.checkedEsito;
                if(this.checkedEsito === ""){
                    dataUpdate.Eseguito = 0;
                }else{
                    dataUpdate.Eseguito = 1;
                }
            }
            this.doApiCall("post", "interventi/UpdateOperazione", this.$store.getters.getUtente.Token, null, dataUpdate).then(

                (data) => {  
                    if(data && data.StatusCode === 200){                    
                        this.$toast.success("Operazione aggiornata con successo!", {position:"top-right"});  

                        let index = this.$parent.$data.listaOperazioni.findIndex(item => {return item.SysChiaveglobale === data.Data.SysChiaveglobale});
                        if(index >= 0) this.$parent.$data.listaOperazioni[index] = data.Data; 
                        this.$parent.$forceUpdate();                                         
                    }
                    else{
                        this.$toast.error("Attenzione! Si sono verificati errori durante l'aggiornamento dell'operazione!", {position:"top-right"});
                    }
                }
            );
        },
        clearSelection: function(){
            this.checkedEsito = "";
            this.userInput();
        },
        userInput: function(){
            this.userIn = true;
        }
    },
    watch:{
        checkedEsito: function(newValue){
            let classList = this.$refs.FormBox.classList;
            if( newValue === "1POSITIVO"){
                this.resetVisible = true;
                classList.add('StorkedBoxGreen');
                classList.remove('StorkedBoxRed');
            }
            if( newValue === "0NEGATIVO"){
                this.resetVisible = true;
                classList.add('StorkedBoxRed');
                classList.remove('StorkedBoxGreen');
            }
            if( newValue === "0NONAPPLICABILE" || newValue ===""){
                if(newValue === "0NONAPPLICABILE"){
                    this.resetVisible = true;
                    classList.add('StorkedBoxGrey');
                }else{
                    this.resetVisible = false;
                    classList.remove('StorkedBoxGrey');
                }
                classList.add('StorkedBox'); 
                classList.remove('StorkedBoxRed');
                classList.remove('StorkedBoxGreen');
            }

            if(this.userIn){
                this.updateOperazione(0,1);
            }
        }
    },
    mounted: function(){
        this.checkedEsito = this.operazione.CodiceEsito;
    }
}
</script>

<style>
    .StorkedBox{
        border: 1px solid rgb(112, 112, 112);
        text-align: center;
    }
    .StorkedBoxGreen{
        border: 2px solid #6ab20c;
    }
    .StorkedBoxRed{
        border: 2px solid #f91e33;
    }
    .StorkedBoxGrey{
        border: 2px solid rgb(112, 112, 112);
    }
    .Centeredtext{
        text-align: center;
    }
    .radioPersGreen:checked:after{
        background-color: #6ab20c;
        border: 0px;
    }
    .myPadding{
        padding-top: 4px;
        padding-bottom: 4px;
    }

</style>